import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchSignupGenerator,
  updateSignupGenerator,
  clearUpdateSignupGeneratorStatus,
} from 'redux/signup-generator/actions';

import { Checkbox } from 'semantic-ui-react';

import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';

import './SignupGeneratorColorsSelector.css';

class SignupGeneratorColorsSelector extends Component {
  static propTypes = {
    fetchSignupGenerator: PropTypes.func.isRequired,
    updateSignupGenerator: PropTypes.func.isRequired,
    clearUpdateSignupGeneratorStatus: PropTypes.func.isRequired,
    me: PropTypes.object,
    signupGenerator: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    signupGenerator: null,
  };

  state = {
    currentButtonColor: null,
    currentButtonBorderColor: null,
    currentButtonTextColor: null,
    currentMessageTextColor: null,
    currentMessageColor: null,
  };

  componentDidMount() {
    const { me, signupGenerator } = this.props;

    if (signupGenerator.is_custom_colors) {
      this.setState({
        currentButtonColor: signupGenerator.button_color,
        currentButtonBorderColor: signupGenerator.button_border_color,
        currentButtonTextColor: signupGenerator.button_text_color,
        currentMessageColor: signupGenerator.success_message_color,
        currentMessageTextColor: signupGenerator.success_message_text_color,
      });
    } else {
      this.setState({
        currentButtonColor: me.custom_theme.button_color,
        currentButtonBorderColor: me.custom_theme.button_border_color,
        currentButtonTextColor: me.custom_theme.button_font_color,
        currentMessageColor: me.custom_theme.button_color,
        currentMessageTextColor: me.custom_theme.button_font_color,
      });
    }
  }

  setDefaultValues = () => {
    const form = new FormData();
    form.append('button_color', this.props.me.custom_theme.button_color);
    form.append('button_border_color', this.props.me.custom_theme.button_border_color);
    form.append('button_text_color', this.props.me.custom_theme.button_font_color);
    form.append('success_message_color', this.props.me.custom_theme.button_color);
    form.append('success_message_text_color', this.props.me.custom_theme.button_font_color);
    this.props.updateSignupGenerator(this.props.me.signup_generator, form);

    this.setState({
      currentButtonColor: this.props.me.custom_theme.button_color,
      currentButtonBorderColor: this.props.me.custom_theme.button_border_color,
      currentButtonTextColor: this.props.me.custom_theme.button_font_color,
      currentMessageColor: this.props.me.custom_theme.button_color,
      currentMessageTextColor: this.props.me.custom_theme.button_font_color,
    });

    setTimeout(() => {
      this.props.fetchSignupGenerator(this.props.me.signup_generator);
    }, 1000);
  };

  onPatchSignupGenerator = (parameter, value) => {
    const form = new FormData();
    form.append(parameter, value);
    this.props.updateSignupGenerator(this.props.me.signup_generator, form);
  };

  onButtonColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchSignupGenerator('button_color', rgba);
    this.setState({ currentButtonColor: rgba });
  };

  onButtonBorderColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchSignupGenerator('button_border_color', rgba);
    this.setState({ currentButtonBorderColor: rgba });
  };

  onButtonTextColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchSignupGenerator('button_text_color', rgba);
    this.setState({ currentButtonTextColor: rgba });
  };

  onMessageColor = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchSignupGenerator('success_message_color', rgba);
    this.setState({ currentMessageColor: rgba });
  };

  onMessageTextColor = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchSignupGenerator('success_message_text_color', rgba);
    this.setState({ currentMessageTextColor: rgba });
  };

  onCheckboxChange = () => {
    const form = new FormData();
    form.append('is_custom_colors', !this.props.signupGenerator.is_custom_colors);
    this.props.updateSignupGenerator(this.props.me.signup_generator, form);

    this.setDefaultValues();
  };


  render() {
    const { signupGenerator, me } = this.props;

    const isButtonBackgroundColorAvailable = me && me.custom_theme &&
      ![
        'button-style-06',
        'button-style-07',
        'button-style-08',
        'button-style-09',
        'button-style-10',
      ].includes(me.custom_theme.button_style);

    const isButtonBorderColorAvailable = me && me.custom_theme &&
      ![
        'button-style-01',
        'button-style-02',
        'button-style-03',
        'button-style-04',
      ].includes(me.custom_theme.button_style);

    if (!signupGenerator) return null;

    return (
      <Translation>
        {(t) => (
          <div className="signup-generator-colors-selector__component">
            <div className="title-block">
              <div className="title">{t("Appearance")}</div>
              <div className="checkbox-container">
                <div className="label">{t("OFF")}</div>
                <Checkbox
                  toggle
                  checked={signupGenerator.is_custom_colors}
                  onChange={this.onCheckboxChange}
                />
                <div className="label">{t("ON")}</div>
              </div>
            </div>

            {signupGenerator.is_custom_colors &&
            <div className="color-selectors-wrapper">

              {/* Button Color */}
              {isButtonBackgroundColorAvailable &&
                <div className="section">
                  <div className="selector-title">{t("Button Color")}</div>
                  <ColorPicker
                    small
                    key="signup-generator-button-color-picker-key"
                    pickerId="signup-generator-button-color-picker-id"
                    color={this.state.currentButtonColor || '#bebebe'}
                    onChangeComplete={this.onButtonColorChange}
                    disableAlpha
                  />
                </div>
              }

              {/* Button Border Color */}
              {isButtonBorderColorAvailable &&
                <div className="section">
                  <div className="selector-title">{t("Button Border Color")}</div>
                  <ColorPicker
                    small
                    key="signup-generator-button-border-color-picker-key"
                    pickerId="signup-generator-button-border-color-picker-id"
                    color={this.state.currentButtonBorderColor || '#bebebe'}
                    onChangeComplete={this.onButtonBorderColorChange}
                    disableAlpha
                    name="someName"
                  />
                </div>
              }

              {/* Button Text Color */}
              <div className="section">
                <div className="selector-title">{t("Button Text Color")}</div>
                <ColorPicker
                  small
                  key="signup-generator-button-text-color-picker-key"
                  pickerId="signup-generator-button-text-color-picker-id"
                  color={this.state.currentButtonTextColor || '#bebebe'}
                  onChangeComplete={this.onButtonTextColorChange}
                  disableAlpha
                />
              </div>

              {/* Success Message Color */}
              {isButtonBackgroundColorAvailable &&
                <div className="section">
                  <div className="selector-title">{t("Success Message Color")}</div>
                  <ColorPicker
                    small
                    key="signup-generator-message-color-picker-key"
                    pickerId="signup-generator-message-color-picker-id"
                    color={this.state.currentMessageColor || '#bebebe'}
                    onChangeComplete={this.onMessageColor}
                    disableAlpha
                  />
                </div>
              }

              {/* Success Message Text Color */}
              <div className="section">
                <div className="selector-title">{t("Success Message Text Color")}</div>
                <ColorPicker
                  small
                  key="signup-generator-message-text-color-picker-key"
                  pickerId="signup-generator-message-text-color-picker-id"
                  color={this.state.currentMessageTextColor || '#bebebe'}
                  onChangeComplete={this.onMessageTextColor}
                  disableAlpha
                />
              </div>

            </div>
            }

          </div>
        )}
      </Translation>
    );
  }
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    signupGenerator: state.emailSignupGenerator.signupGenerator,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchSignupGenerator,
    updateSignupGenerator,
    clearUpdateSignupGeneratorStatus,
  },
)(SignupGeneratorColorsSelector);
